export default __webpack_public_path__ + "static/media/IMG-20241005-WA0005.bf5ab96d.jpg";